
document.addEventListener('DOMContentLoaded', function(e) {
  var isHomepage = document.body.dataset.isHomepage == '1';
  var jumboHeight = isHomepage ? document.getElementsByClassName('js_jumbo')[0].offsetHeight : null;
  var topbar = document.getElementsByClassName('js_topBar')[0];
  var topbarHeight = topbar.offsetHeight;

  window.onscroll = function() {
    var offset = window.pageYOffset;
    if (offset > 0) {
      if (isHomepage) {
        if (offset <= topbarHeight) {
          document.body.classList.remove('no-padding');
          topbar.classList.remove('hidden');
        } else if (offset <= (jumboHeight - 150)) {
          topbar.classList.add('hidden');
          document.body.classList.add('no-padding');
        } else {
          topbar.classList.remove('hidden');
          document.body.classList.add('sticky');
        }
      } else {
        document.body.classList.add('sticky');
      }
    } else {
      document.body.classList.remove('sticky');
    }
  };

});
